import { Box, Checkbox, Typography } from '@mui/material';
import React from 'react';
import { ProductInvoiceModel } from 'shared/types/Products';

import { COLOR } from '@/theme/colors';

type Props = {
    items: ProductInvoiceModel[];
    selectedItems?: Set<ProductInvoiceModel>;
    onItemClick?: (item: ProductInvoiceModel) => void;
    multiSelect?: boolean;
    testIdPrefix?: string;
};

function InvoicingProductsList({
    items,
    selectedItems,
    onItemClick,
    testIdPrefix,
}: Props) {
    return (
        <Box className="flex flex-col gap-2">
            {items.map((product) => {
                const isSelected = selectedItems?.has(product) ?? false;
                const isAvailable = product.available !== false;

                return (
                    <Box
                        key={product.id}
                        className="flex items-center gap-3"
                        onClick={
                            isAvailable
                                ? () => onItemClick?.(product)
                                : undefined
                        }
                        data-test-id={`${testIdPrefix}-Product-${product.id}`}
                    >
                        {isAvailable ? (
                            <Checkbox
                                checked={isSelected}
                                size="small"
                                sx={{ p: 0 }}
                            />
                        ) : (
                            <Box sx={{ width: 20 }} />
                        )}
                        <Box
                            className={`flex items-center flex-1 gap-3 p-3 rounded-lg bg-athensGrayDarker ${
                                isAvailable ? 'cursor-pointer' : 'opacity-50'
                            }`}
                        >
                            <Typography className="flex-1 truncate">
                                {product.name}
                            </Typography>
                            <Typography
                                variant="body2"
                                color={COLOR.regentGray}
                            >
                                ${product.price}
                            </Typography>
                        </Box>
                    </Box>
                );
            })}
        </Box>
    );
}

export default InvoicingProductsList;
